import React from "react";
import useTrait from "../Common/syncUpdateState";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import VehicleSearchTabComponent from "./VehicleSearchTabComponent";

const VehicleSearchComponent = (props) => {
  const isAU = process.env.NEXT_PUBLIC_SITE_IS_AU == "true";

  const tabs = [
    { id: 0, name: "Passenger vehicles" },
    { id: 1, name: "Motorcycle" },
    { id: 2, name: "Heavy Commercial" },
    { id: 3, name: "Industrial & agricultural" },
    { id: 4, name: "Marine" },
  ];

  const types = [
    { id: 0, name: "Passenger & light commercial" },
    { id: 1, name: "Motorcycle" },
    { id: 2, name: "Heavy Commercial" },
    { id: 3, name: "Industrial & Agricultural" },
    { id: 4, name: "Marine" },
  ];

  const title = useTrait(types[0]);

  return (
    <>
      <div className='overflow-auto mx-2'>
        <ul
          className='nav nav-tabs custom-tabs flex-nowrap text-nowrap custom-tabs-filled-light border-0 justify-content-md-center'
          id='myTab1'
          role='tablist'
        >
          {tabs.map((tab) => (
            <li
              className='nav-item'
              key={tab.id}
              onClick={() => title.set(types[tab.id])}
            >
              <button
                className={title.get()?.id === tab.id ? "nav-link active" : "nav-link"}
                id={`vehicle-type-tab-${tab.id}`}
                data-bs-toggle='tab'
                data-bs-target='#passenger-vehicles'
                type='button'
                role='tab'
                aria-controls='passenger-vehicles'
                aria-selected={title.get()?.id === tab.id}
              >
                {tab.name}
              </button>
            </li>
          ))}
        </ul>
      </div>
      {/* child tab content */}
      <div className={`tab-content InnerTabs`} id='myTabContent3'>
        <div
          className='tab-pane fade show active'
          id='passenger-vehicles'
          role='tabpanel'
          aria-labelledby='passenger-vehicles-tab'
        >
    
          <VehicleSearchTabComponent
            title={`Vehicle Type - ${title.get()?.name}`}
            tab={title.get()?.id}
          />
     
        
        </div>
      </div>
    </>
  );
};

export default VehicleSearchComponent;
